import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { PERMISSION_KEYS } from '../config/permissions'
import { loadingClass } from '../lib/ui'

/** Доступ к разделу «Планирование»: хотя бы одна вкладка по правам. */
export function RequirePlanningAccess({ children }: { children: ReactNode }) {
  const { can, loading } = useAuth()

  if (loading) {
    return (
      <div className={loadingClass}>
        <p>Загрузка…</p>
      </div>
    )
  }

  const hasAccess =
    can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ) ||
    can(PERMISSION_KEYS.PRODUCTION_REQUESTS_READ) ||
    can(PERMISSION_KEYS.TIMESHEETS_READ) ||
    can(PERMISSION_KEYS.MATERIALS_READ) ||
    can(PERMISSION_KEYS.PLANNING_KIOSK) ||
    can(PERMISSION_KEYS.MACHINE_EVENTS_READ)

  if (!hasAccess) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
